// Hostname convention shared with the sibling frontends:
// <taxiSystemCode>-pakketransport.itf-as.com → https://<taxiSystemCode>-bookingterminalapi.itf-as.com/api/v1/
// A leaf on purpose — Sentry and analytics read it at start-up, and pulling in the request layer for it made a
// circle back to Sentry through the error telemetry.
export function getTaxiSystemCode(): string {
  const url = window.location.origin.toLowerCase()
  if (url.includes("-pakketransport")) {
    const code = url.split("-pakketransport")[0]?.split("://")[1]
    return code || "itf"
  }
  return "itf"
}
